var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 40,
    viewBox: "0 0 175 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_42_499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 19.8191C0.0513943 16.0963 1.25916 12.9252 3.6233 10.2932C5.99385 7.66121 8.83339 6.34839 12.1612 6.34839C15.4889 6.34839 18.3477 7.66756 20.7183 10.3122C23.0889 12.9442 24.2902 16.128 24.3288 19.8572V32.7445H22.4529V19.8572C22.4143 16.6988 21.3993 14.0097 19.4013 11.7773C17.3905 9.55118 14.9814 8.43496 12.1676 8.43496C9.35375 8.43496 6.95107 9.54484 4.95312 11.7583C2.95517 13.9717 1.93371 16.6607 1.88231 19.8191V32.7445H0V19.8191Z",
    fill: "#21273C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8876 6.36108H24.2132L35.8732 28.1718L47.4755 6.36108H49.9103L37.1902 30.2457V30.2647L35.8668 32.6874L34.6205 30.3345L21.8876 6.36108Z",
    fill: "#6BCAD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5528 32.6874H51.5999V6.36108H53.5528V32.6874Z",
    fill: "#6BCAD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8927 32.6874H83.9397V6.36108H85.8927V32.6874Z",
    fill: "#6BCAD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.645 5.93628C105.429 5.93628 108.654 7.25545 111.333 9.90013C114.012 12.5448 115.348 15.7349 115.348 19.4641C115.348 23.1933 114.012 26.3834 111.333 29.0281C108.654 31.6728 105.422 32.9919 101.645 32.9919C97.8675 32.9919 94.6361 31.6728 91.9572 29.0281C89.2783 26.3834 87.942 23.1996 87.942 19.4641C87.942 15.7286 89.2783 12.5448 91.9572 9.90013C94.6361 7.25545 97.8611 5.93628 101.645 5.93628ZM101.645 31.0893C104.896 31.0893 107.671 29.9604 109.977 27.6899C112.271 25.413 113.421 22.6732 113.421 19.4641C113.421 16.255 112.271 13.5152 109.977 11.2383C107.671 8.97417 104.896 7.83893 101.645 7.83893C98.3943 7.83893 95.619 8.97417 93.3127 11.2383C91.0192 13.5152 89.8693 16.255 89.8693 19.4641C89.8693 22.6732 91.0128 25.413 93.3127 27.6899C95.619 29.954 98.3943 31.0893 101.645 31.0893Z",
    fill: "#6BCAD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.397 19.8191C117.449 16.0963 118.656 12.9252 121.021 10.2932C123.391 7.66121 126.231 6.34839 129.559 6.34839C132.886 6.34839 135.745 7.66756 138.116 10.3122C140.486 12.9442 141.688 16.128 141.726 19.8572V32.7445H139.85V19.8572C139.812 16.6988 138.797 14.0097 136.799 11.7773C134.788 9.55118 132.379 8.43496 129.565 8.43496C126.751 8.43496 124.348 9.54484 122.35 11.7583C120.353 13.9717 119.331 16.6607 119.28 19.8191V32.7445H117.404V19.8191H117.397Z",
    fill: "#6BCAD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.103 6.34204H145.979V19.2674C146.03 22.4258 147.052 25.1085 149.05 27.3282C151.048 29.5417 153.45 30.6515 156.264 30.6515C159.078 30.6515 161.487 29.5353 163.498 27.3092C165.496 25.0831 166.511 22.3877 166.55 19.2293V6.34204H168.425V19.2293C168.387 22.9648 167.186 26.1423 164.815 28.7743C162.444 31.4189 159.598 32.7381 156.258 32.7381C152.917 32.7381 150.091 31.4253 147.72 28.7933C145.349 26.1613 144.142 22.9839 144.097 19.2674V6.34204H144.103Z",
    fill: "#21273C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3942 39.6828C51.0602 39.1755 53.3987 37.85 55.3388 36.0995C59.2319 32.6431 61.3584 27.7215 63.549 22.8634C68.1938 12.6462 74.7658 3.15836 85.8798 0.748335C88.5588 0.177541 91.3598 0.158514 93.9744 0.79273C88.5909 0.259989 83.3358 2.05482 79.0701 5.00392C69.0225 11.9613 65.3286 24.3982 61.307 30.6706C59.7716 33.0553 58.1976 35.0277 55.9041 36.7655C53.6621 38.4271 51.2208 39.5433 48.3942 39.6828Z",
    fill: "url(#paint0_linear_42_499)",
    stroke: "url(#paint1_linear_42_499)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.331 5.06286H171.618V6.97185H171.464V5.06286H170.757V4.91064H172.331V5.06286Z",
    fill: "#21273C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.4 4.90893V6.97013H174.239V5.54949L173.443 6.97013L172.653 5.56217V6.97013H172.492V4.90259L173.449 6.59594L174.394 4.90893H174.4Z",
    fill: "#21273C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_42_499",
    x1: 71.1811,
    y1: 0.317068,
    x2: 71.1811,
    y2: 39.6828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6F70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#787A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#969898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#C7C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B7B8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D6F70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_42_499",
    x1: 71.1939,
    y1: -0.00003984,
    x2: 71.1939,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6F70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#787A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#969898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#C7C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B7B8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D6F70"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_42_499"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 174.4,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fd26e44c168319dc7f0a68a4a03cc955.svg";
export { ForwardRef as ReactComponent };